function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDedicated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1080 1432",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-536.685,-785.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dedicated"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ribbon-Border",
    d: "M777.976,1775.02C632.582,1678.31 536.685,1512.98 536.685,1325.43C536.685,1027.63 778.462,785.853 1076.26,785.853C1374.06,785.853 1615.84,1027.63 1615.84,1325.43C1615.84,1512.66 1520.28,1677.74 1375.31,1774.52L1501.35,2113.29C1506.26,2126.49 1497.78,2140.62 1482.42,2144.85L1340.34,2110.68L1248.69,2209.07C1233.32,2213.29 1216.88,2206.01 1211.97,2192.8L1089.95,1864.84C1085.4,1864.95 1080.84,1865.01 1076.26,1865.01C1072.03,1865.01 1067.8,1864.96 1063.59,1864.86L939.279,2199.82C934.366,2213.06 917.926,2220.36 902.559,2216.13L810.904,2117.49L668.83,2151.75C653.463,2147.51 644.989,2133.35 649.903,2120.11L777.976,1775.02Z",
    style: {
      fill: "white",
      fillOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inner-Circle",
    transform: "matrix(-1,0,0,1,2149.79,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1074.89,
    cy: 1325.52,
    r: 503.155,
    style: {
      fill: "rgb(150,232,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right-Tail",
    transform: "matrix(1,0,0,1,4,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1100.71,1864.27C1195.52,1859.34 1283.88,1829.88 1359.58,1782.13L1477.01,2097.75C1481.46,2109.73 1473.77,2122.55 1459.83,2126.38L1330.91,2095.38L1247.74,2184.66C1233.79,2188.49 1218.87,2181.88 1214.42,2169.9L1100.71,1864.27Z",
    style: {
      fill: "url(#_Linear1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Left-Tail",
    transform: "matrix(1,0,0,1,3,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1046.07,1864.33L930.237,2176.43C925.789,2188.41 910.906,2195.02 896.994,2191.19L814.016,2101.89L685.393,2132.9C671.482,2129.07 663.81,2116.25 668.258,2104.26L787.459,1783.08C863.149,1830.48 951.413,1859.62 1046.07,1864.33Z",
    style: {
      fill: "url(#_Linear2)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right-Plant",
    transform: "matrix(1.79448,-0.476227,0.476227,1.79448,1082.41,1506.45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.347,101.005C91.228,106.958 94.737,113.767 92.576,128.035C91.922,132.355 91.371,138.469 91.702,143.922",
    style: {
      fill: "none",
      stroke: "rgb(27,80,41)",
      strokeWidth: "2.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.381,118.866C101.381,118.866 92.531,125.998 92.166,131.07",
    style: {
      fill: "none",
      stroke: "rgb(27,80,41)",
      strokeWidth: "2.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.608,123.607C87.608,123.607 92.58,124.509 91.756,135.953",
    style: {
      fill: "none",
      stroke: "rgb(27,80,41)",
      strokeWidth: "2.7px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.934349,2.99734e-33,-2.99734e-33,0.934349,6.38935,7.47158)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0356631,0.0271214,0.0271214,0.0356631,88.7097,79.5993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979.5,355.093C953.869,356.051 815.841,350.848 703.324,407.654C539.389,490.419 528.069,653.939 533.981,697.433C540.003,741.735 572.786,780.781 616.841,803.546C678.76,835.542 762.947,835.375 826.398,772.434C909.312,690.185 934.05,591.018 958.884,529.98C1000.56,427.557 1051.29,386.198 1081,355.385C1030.17,355.239 1030.3,354.314 979.5,355.093",
    style: {
      fill: "rgb(20,111,36)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0356631,0.0271214,0.0271214,0.0356631,88.7097,79.5993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979.5,355.093C953.869,356.051 815.841,350.848 703.324,407.654C539.389,490.419 528.069,653.939 533.981,697.433C540.003,741.735 573.506,779.438 616.841,803.546C632.495,812.255 543.076,556.196 1081,355.385C1030.17,355.239 1030.3,354.314 979.5,355.093",
    style: {
      fill: "rgb(50,154,75)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0448018,0.000473358,0.000473358,0.0448018,116.072,67.057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979.5,355.093C953.869,356.051 788.66,371.886 676.142,428.692C512.207,511.457 528.069,653.939 533.981,697.433C548.467,804.002 717.803,880.157 826.398,772.434C909.312,690.185 930.045,585.08 954.879,524.041C996.551,421.618 1051.29,386.198 1081,355.385C1030.17,355.239 1030.3,354.314 979.5,355.093",
    style: {
      fill: "rgb(50,154,75)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0448018,0.000473358,0.000473358,0.0448018,116.072,67.057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.346,794.571C665.802,832.316 757.475,840.803 826.398,772.434C909.312,690.185 930.045,585.08 954.879,524.041C996.551,421.618 1051.29,386.198 1081,355.385C574.434,534.286 591.097,788.569 601.346,794.571Z",
    style: {
      fill: "rgb(20,111,36)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0494316,0.025519,-0.025519,0.0494316,91.6832,65.0288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979.5,355.093C953.869,356.051 801.137,369.392 688.62,426.198C524.685,508.963 528.069,653.939 533.981,697.433C548.467,804.002 717.803,880.157 826.398,772.434C909.312,690.185 928.994,581.713 953.829,520.674C995.501,418.251 1051.29,386.198 1081,355.385C1030.17,355.239 1030.3,354.314 979.5,355.093",
    style: {
      fill: "rgb(50,154,75)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0494316,0.025519,-0.025519,0.0494316,91.6832,65.0288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595.285,790.48C659.222,832.783 755.219,843.041 826.398,772.434C909.312,690.185 928.994,581.713 953.829,520.674C995.501,418.251 1051.29,386.198 1081,355.385C619.807,528.723 587.555,785.365 595.285,790.48Z",
    style: {
      fill: "rgb(20,111,36)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Left-Plant",
    transform: "matrix(-1.84598,-0.198222,-0.198222,1.84598,1382.3,1531.39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.347,101.005C91.228,106.958 94.737,113.767 92.576,128.035C91.922,132.355 91.371,138.469 91.702,143.922",
    style: {
      fill: "none",
      stroke: "rgb(27,80,41)",
      strokeWidth: "2.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.381,118.866C101.381,118.866 92.531,125.998 92.166,131.07",
    style: {
      fill: "none",
      stroke: "rgb(27,80,41)",
      strokeWidth: "2.7px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.850936,0.0580532,-0.0580532,0.850936,21.7881,17.9677)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0448018,0.000473358,0.000473358,0.0448018,116.072,67.057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979.5,355.093C953.869,356.051 788.66,371.886 676.142,428.692C512.207,511.457 528.069,653.939 533.981,697.433C548.467,804.002 717.803,880.157 826.398,772.434C909.312,690.185 930.045,585.08 954.879,524.041C996.551,421.618 1051.29,386.198 1081,355.385C1030.17,355.239 1030.3,354.314 979.5,355.093",
    style: {
      fill: "rgb(50,154,75)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0448018,0.000473358,0.000473358,0.0448018,116.072,67.057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.346,794.571C665.802,832.316 757.475,840.803 826.398,772.434C909.312,690.185 930.045,585.08 954.879,524.041C996.551,421.618 1051.29,386.198 1081,355.385C574.434,534.286 591.097,788.569 601.346,794.571Z",
    style: {
      fill: "rgb(20,111,36)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.718404,-4.22719e-18,4.22719e-18,0.718404,25.6463,36.4766)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0494316,0.025519,-0.025519,0.0494316,91.6832,65.0288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979.5,355.093C953.869,356.051 801.137,369.392 688.62,426.198C524.685,508.963 528.069,653.939 533.981,697.433C548.467,804.002 717.803,880.157 826.398,772.434C909.312,690.185 928.994,581.713 953.829,520.674C995.501,418.251 1051.29,386.198 1081,355.385C1030.17,355.239 1030.3,354.314 979.5,355.093",
    style: {
      fill: "rgb(50,154,75)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0494316,0.025519,-0.025519,0.0494316,91.6832,65.0288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595.285,790.48C659.222,832.783 755.219,843.041 826.398,772.434C909.312,690.185 928.994,581.713 953.829,520.674C995.501,418.251 1051.29,386.198 1081,355.385C619.807,528.723 587.555,785.365 595.285,790.48Z",
    style: {
      fill: "rgb(20,111,36)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Sunflower"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stem",
    transform: "matrix(1,0,0,1,-16.55,-17.9914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.172,1110.33C859.782,1101.64 722.275,1210.93 735.022,1413.91C740.298,1497.93 745.029,1594.02 839.268,1737.44",
    style: {
      fill: "none",
      stroke: "rgb(101,215,80)",
      strokeWidth: "13.92px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Petals"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.514,981.299C822.412,1005.79 887.313,1079.64 894.139,1062.67L905.583,1045.76C906.776,1044.4 911.867,1030 903.115,1021.75C900.777,1019.54 897.09,1017.12 894.618,1015.26C890.97,1012.52 878.581,1011.71 874.777,1009.26C869.079,1005.59 863.297,1001.94 857.703,997.368C847.767,989.253 838.654,979.449 837.514,981.299Z",
    style: {
      fill: "rgb(254,209,72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.427,1024.32C810.529,1011.19 901.63,1051.29 896.466,1061.77L894.059,1073.8C900.617,1096.77 810.152,1059.66 810.427,1024.32Z",
    style: {
      fill: "rgb(248,182,55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.953,1076.36C817.29,1060.85 898.624,1062.85 892.514,1070.38L894.328,1098.77C893.685,1100.79 880.488,1103.95 864.156,1100.37C851.504,1097.59 837.669,1089.37 828.061,1086.3C808.224,1079.97 808.882,1081.42 810.953,1076.36Z",
    style: {
      fill: "rgb(247,151,24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.109,1110.51C903.611,1121.77 809.597,1134.83 809.674,1118.15C809.775,1096.2 905.022,1076.78 893.464,1089.27L898.109,1110.51Z",
    style: {
      fill: "rgb(254,209,72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.383,1106.34C890.307,1100.25 864.234,1116.68 848.089,1135.43C838.374,1146.71 831.347,1149.84 832.727,1153.55C839.437,1171.57 913.114,1135.04 906.222,1129.37L890.383,1106.34Z",
    style: {
      fill: "rgb(248,182,55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.736,1109.77C884.108,1104.13 841.808,1190.63 855.316,1204.57C863.789,1213.31 914.635,1136.81 908.608,1130.6L894.736,1109.77Z",
    style: {
      fill: "rgb(254,209,72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.912,1214.69C881.371,1213.2 891.181,1128.42 902.101,1127.93L917.145,1137.15C926.994,1148.21 916.303,1215.88 900.912,1214.69Z",
    style: {
      fill: "rgb(248,182,55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.844,1136.24C946.486,1132.22 960.209,1207.03 942.139,1212.67C937.739,1214.04 935.988,1205.55 929.988,1194.13C925.568,1185.72 912.684,1172.67 909.208,1162.74C902.825,1144.51 903.471,1130.93 907.625,1129.59L937.844,1136.24Z",
    style: {
      fill: "rgb(254,209,72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.571,1183.31C963.229,1189.54 913.719,1141.66 922.198,1137.52L943.686,1121.71C953.237,1119.02 988.335,1177.82 976.571,1183.31Z",
    style: {
      fill: "rgb(247,151,24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.05,1156.7C1001.34,1168.45 925.976,1133.19 936.158,1125.91L947.275,1106.79C950.234,1096.37 1028.33,1143.49 1014.05,1156.7Z",
    style: {
      fill: "rgb(254,209,72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.02,1109.25C1016.18,1122.23 944.847,1131.45 944.669,1123.43L948.86,1086.24C950.329,1084.97 1020.45,1102.75 1019.02,1109.25Z",
    style: {
      fill: "rgb(248,182,55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.24,1065.02C1001.51,1080.6 944.941,1115.94 948.855,1106.78L937.718,1066.64C937.718,1066.64 1004.04,1057.75 1003.24,1065.02Z",
    style: {
      fill: "rgb(247,151,24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.82,1030.68C995.639,1018.28 932.438,1050.34 934.843,1056.61L950.771,1083.77C956.046,1087.99 1009.55,1042.3 1002.82,1030.68Z",
    style: {
      fill: "rgb(248,182,55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.144,1008.27C978.289,1000.48 926.949,1041.01 929.55,1044.13L944.869,1064.42C952.515,1069 998.104,1017.92 987.144,1008.27Z",
    style: {
      fill: "rgb(254,209,72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.382,975.926C954.614,969.071 911.053,1031.9 915.65,1038.81L940.338,1049.86C959.027,1026.56 971.441,979.784 965.382,975.926Z",
    style: {
      fill: "rgb(248,182,55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.78,956.498C909.124,958.079 901.978,1014.81 912.08,1044.3L930.624,1042.67C940.228,1000.11 923.016,954.779 915.78,956.498Z",
    style: {
      fill: "rgb(254,209,72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.731,1009.23C867.488,987.311 865.068,966.94 870.626,963.203C878.36,958.002 917.478,1000.9 928.775,1037.52L905.277,1046.21L905.583,1045.76C906.776,1044.4 901.976,1031.2 893.224,1022.95C887.422,1017.48 881.129,1013.35 874.731,1009.23Z",
    style: {
      fill: "rgb(248,182,55)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.37623,-0.295171,0.211002,1.69864,-1514.77,-483.524)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 927.922,
    cy: 1086.85,
    rx: 14.521,
    ry: 33.613,
    style: {
      fill: "rgb(173,129,58)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.46241,-0.181659,0.129858,1.0454,-576.65,120.598)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 927.922,
    cy: 1086.85,
    rx: 14.521,
    ry: 33.613,
    style: {
      fill: "rgb(115,89,46)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Water-Can",
    transform: "matrix(0.746493,-0.665393,0.665393,0.746493,746.265,1358.22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.704269,0.548063,-1.03531,1.33038,467.1,-1135.57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M965.626,576.583C1019.65,576.583 1055.44,604.428 1055.44,644.492C1055.44,684.555 1001.82,761.712 947.8,761.712C893.778,761.712 871.203,689.317 871.203,649.254C871.203,609.19 911.604,576.583 965.626,576.583ZM961.488,592.252C922.449,593.065 894.604,615.307 898.105,643.869C902.017,675.774 944.314,740.17 944.56,740.163C983.419,739.019 1019.56,670.198 1019.16,640.627C1018.77,612.007 1000.05,591.448 961.488,592.252Z",
    style: {
      fill: "rgb(255,140,78)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.23317,0.628947,-0.276002,0.979986,-869.384,-715.627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.027,682.284C486.361,684.109 480.831,691.727 473.331,702.998L473.265,617.818C480.08,628.055 488.464,643.346 493.722,646.141C507.856,653.654 530.744,658.953 558.35,659.996L557.313,723.438C529.512,698.591 500.706,679.487 492.027,682.284Z",
    style: {
      fill: "rgb(255,140,78)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.59258,0,0,1.03311,-869.7,-450.676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M779.836,592.963C801.252,657.376 818.251,724.175 831.225,791.627C834.917,810.694 832.588,831.327 824.936,847.352C817.283,863.377 805.195,872.935 792.288,873.166C764.488,873.673 730.3,874.287 701.792,874.798C687.246,875.059 673.382,865.315 663.971,848.216C654.56,831.117 650.582,808.443 653.118,786.363C659.978,726.669 670.282,664.86 692.254,594.682L779.836,592.963Z",
    style: {
      fill: "rgb(255,140,78)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.59258,0,0,1.03311,-869.7,-450.676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M759.499,593.362L779.836,592.963C801.252,657.376 818.251,724.175 831.225,791.627C834.917,810.694 832.588,831.327 824.936,847.352C817.283,863.377 805.195,872.935 792.288,873.166C764.488,873.673 730.3,874.287 701.792,874.798C687.246,875.059 673.382,865.315 663.971,848.216C661.079,842.961 658.699,837.179 656.865,831.049C666.017,844.356 678.218,851.789 690.943,851.564C715.2,851.134 743.23,850.639 766.944,850.216C779.926,849.986 792.076,840.323 799.721,824.147C807.366,807.971 809.609,787.181 805.771,768.061C793.911,708.753 778.594,650.053 759.499,593.362Z",
    style: {
      fill: "rgb(243,116,47)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.961477,-0.0151163,0.0178972,1.13836,-455.787,-503.629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 777.521,
    cy: 598.54,
    rx: 68.711,
    ry: 10.735,
    style: {
      fill: "none",
      stroke: "rgb(255,191,157)",
      strokeWidth: "8.54px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 777.521,
    cy: 598.54,
    rx: 68.711,
    ry: 10.735,
    style: {
      fill: "rgb(208,96,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.692712,0.176862,-0.249428,0.97693,-156.205,-499.231)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.111,
    cy: 660.074,
    rx: 20.006,
    ry: 43.265,
    style: {
      fill: "rgb(255,191,157)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.61797,0.157779,-0.224814,0.880525,-139.038,-426.428)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.111,
    cy: 660.074,
    rx: 20.006,
    ry: 43.265,
    style: {
      fill: "rgb(208,96,35)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grass",
    transform: "matrix(-1,0,0,1,2149.79,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1479.82,1624.09C1483.83,1618.66 1488.94,1611.47 1489.12,1611.06C1253.63,1736.93 1264.73,1813.84 939.43,1762.19C854.14,1748.65 816.258,1706.43 787.695,1680.62C723.2,1622.37 671.649,1624.15 669.044,1622.84C673.413,1632.33 698.182,1659.94 716.438,1678.47C807.723,1771.17 934.646,1828.68 1074.89,1828.68C1240.85,1828.68 1388.15,1748.16 1479.82,1624.09Z",
    style: {
      fill: "rgb(7,164,69)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Water-Drops"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.826487,0.562956,-0.412753,0.605971,829.599,164.678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.658,1540.99C837.658,1540.99 844.985,1564.69 844.985,1574.84C844.985,1580.36 841.702,1584.84 837.658,1584.84C833.614,1584.84 830.331,1580.36 830.331,1574.84C830.331,1564.69 837.658,1540.99 837.658,1540.99Z",
    style: {
      fill: "rgb(51,178,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.72078,0.693164,-0.50822,0.528468,1050.61,132.468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.658,1540.99C837.658,1540.99 844.985,1564.69 844.985,1574.84C844.985,1580.36 841.702,1584.84 837.658,1584.84C833.614,1584.84 830.331,1580.36 830.331,1574.84C830.331,1564.69 837.658,1540.99 837.658,1540.99Z",
    style: {
      fill: "rgb(51,178,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.788791,0.614662,-0.450663,0.578333,877.648,174.634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.658,1540.99C837.658,1540.99 844.985,1564.69 844.985,1574.84C844.985,1580.36 841.702,1584.84 837.658,1584.84C833.614,1584.84 830.331,1580.36 830.331,1574.84C830.331,1564.69 837.658,1540.99 837.658,1540.99Z",
    style: {
      fill: "rgb(51,178,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.853149,0.521668,-0.382481,0.625519,729.883,224.133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.658,1540.99C837.658,1540.99 844.985,1564.69 844.985,1574.84C844.985,1580.36 841.702,1584.84 837.658,1584.84C833.614,1584.84 830.331,1580.36 830.331,1574.84C830.331,1564.69 837.658,1540.99 837.658,1540.99Z",
    style: {
      fill: "rgb(51,178,255)"
    }
  }))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(269.549,274.338,-274.338,269.549,1207.43,1850.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7,164,69)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "rgb(5,145,61)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0,85,34)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-112.837,304.762,-304.762,-112.837,903.714,1845.85)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7,164,69)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "rgb(10,150,60)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(20,111,36)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDedicated);
export default __webpack_public_path__ + "static/media/Dedicated.e4e060765183532246507d32f24552e0.svg";
export { ForwardRef as ReactComponent };